import { createFileRoute } from '@tanstack/react-router'
import { Home } from 'lucide-react'
import { useEffect, useMemo } from 'react'
import { ContractDetail } from '@/features/contracts/components/ContractDetail'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/shared/components/ui/breadcrumb'
import { useBreadcrumbs } from '@/shared/hooks/useBreadcrumbs'

export const Route = createFileRoute('/_auth/contracts/$contractId')({
  component: ContractDetailsPage,
})

function ContractDetailsPage() {
  const { contractId } = Route.useParams()
  const { setBreadcrumbs } = useBreadcrumbs()

  const breadcrumbsContent = useMemo(
    () => (
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink to='/dashboard' className='flex items-center gap-1'>
              <Home className='w-4 h-4' />
              Dashboard
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink to='/contracts'>Contracts</BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>{contractId}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    ),
    [contractId]
  )

  useEffect(() => {
    setBreadcrumbs(breadcrumbsContent)
  }, [setBreadcrumbs, breadcrumbsContent])

  return (
    <div className='container mx-auto py-6'>
      <ContractDetail contractId={contractId} />
    </div>
  )
}
